table
<template>
    <div class="d-flex w-100 mb-2">
        <button class="btn btn-primary btn-xs ms-auto" @click="addProblem()">Add Problem</button>
    </div>
    <Pagination
        ref="paginationInstance"
        :page-changed="pageChangedCallback"
        :is-loading="isLoading"
        :page-size="pageLimit"
        :show-page-size-options="false"
    >
        <table class="table table-responsive-md border border-gray overflow-auto">
            <thead>
                <tr class="bg-table-header">
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>Resolution Date</th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <!--Empty Table-->
            <TableEmpty
                v-if="problems?.length === 0 && newProblems?.length === 0"
                :col-span="columns"
                component="problem"
                secondary-message="No Problems to Display"
            />
            <!--Existing Problems-->
            <ProblemsRow
                v-for="(problem, index) of problems"
                :problem="problem"
                :move-problem-up="moveProblem"
                :move-problem-down="moveProblem"
                :delete-problem="deleteProblem"
                v-on:cancelEditProblem="cancelEditProblemChanges"
                :first="index === 0"
                :last="index === problems.length - 1"
                :columns="columns"
                :problems-length="problems.length"
                :index="index"
                current-view="edit"
            />
            <!--New Problems-->
            <ProblemsRow
                v-show="newProblems.length > 0"
                v-for="(problem, index) of newProblems"
                :problem="problem"
                v-model:is-add-requested="isAddRequested"
                :save-new-problem="saveNewProblem"
                :cancel-save-new-problem="cancelSaveNewProblem"
                :index="index"
                current-view="add"
            />
        </table>
    </Pagination>
</template>

<script lang="ts" src="./ProblemsTable.ts" />
